import { useMemo } from "react";
export function useLayoutCellMap(layout) {
    const layoutCellMap = useMemo(() => {
        const cellMap = new Map();
        function addCell(cell) {
            cellMap.set(cell.id, cell);
            if (cell.rows) {
                cell.rows.forEach((row) => row.cells.forEach(addCell));
            }
        }
        layout.rows.forEach((row) => row.cells.forEach(addCell));
        return cellMap;
    }, [layout]);
    return layoutCellMap;
}
//# sourceMappingURL=useLayoutCellMap.js.map